// src/product.ts
var JerseyProducts = ["TSHSM", "TSHPO", "TSHSP"];
var isJerseyProduct = (product) => {
  return product ? JerseyProducts.includes(product.toUpperCase()) : false;
};
var SogProducts = ["SECONTM", "SPREMTM", "SECONCE", "SPREMCE"];
var isSogProduct = (product) => {
  return product ? SogProducts.includes(product.toUpperCase()) : false;
};
var ChannelProducts = ["EECON", "EPREMIUM"];
var isChannelProduct = (product) => {
  return product ? ChannelProducts.includes(product.toUpperCase()) : false;
};
var PaxObProducts = [...JerseyProducts, ...SogProducts, ...ChannelProducts];
var getEconomyProduct = (route) => {
  if (route === "DVDK" || route === "DKDV" || route === "CADV" || route === "DVCA") return "EECON";
  if (route === "TMAL" || route === "ALTM") return "SECONTM";
  if (route === "CEAL" || route === "ALCE") return "SECONCE";
  if (route === "SMSH" || route === "SHSM") return "TSHSM";
  if (route === "SHPO" || route === "POSH") return "TSHPO";
  if (route === "SHSP" || route === "SPSH") return "TSHSP";
  throw new Error(`Unmapped when getting economy product --> ${route}`);
};
var getPremiumProduct = (route) => {
  if (route === "DVDK" || route === "DKDV" || route === "CADV" || route === "DVCA") return "EPREMIUM";
  if (route === "TMAL" || route === "ALTM") return "SPREMTM";
  if (route === "CEAL" || route === "ALCE") return "SPREMCE";
  throw new Error(`Unmapped when getting premium product --> ${route}`);
};

// src/route.ts
var jerseyRoutes = ["SMSH", "SHSM", "SHPO", "POSH", "SHSP", "SPSH"];
var compoundRoutes = ["DVCA", "CADV", "DVDK", "DKDV"];
var sogRoutes = ["TMAL", "ALTM", "CEAL", "ALCE"];
var jerseyUnlocodeRoutes = [
  "FRSML-JESTH",
  "JESTH-FRSML",
  "JESTH-GBPOO",
  "GBPOO-JESTH",
  "JESTH-GGSPT",
  "GGSPT-JESTH"
];
var compoundUnlocodeRoutes = ["GBDVR-FRCQF", "FRCQF-GBDVR", "GBDVR-FRDKK", "FRDKK-GBDVR"];
var sogUnlocodeRoutes = ["MAPTM-ESALG", "ESALG-MAPTM", "ESCEU-ESALG", "ESALG-ESCEU"];
var mapRoute = (legacyRoute) => {
  if (legacyRoute === "DVCA") return { departureUnLoCode: "GBDVR", arrivalUnLoCode: "FRCQF" };
  if (legacyRoute === "CADV") return { departureUnLoCode: "FRCQF", arrivalUnLoCode: "GBDVR" };
  if (legacyRoute === "DVDK") return { departureUnLoCode: "GBDVR", arrivalUnLoCode: "FRDKK" };
  if (legacyRoute === "DKDV") return { departureUnLoCode: "FRDKK", arrivalUnLoCode: "GBDVR" };
  if (legacyRoute === "SMSH") return { departureUnLoCode: "FRSML", arrivalUnLoCode: "JESTH" };
  if (legacyRoute === "SHSM") return { departureUnLoCode: "JESTH", arrivalUnLoCode: "FRSML" };
  if (legacyRoute === "SHPO") return { departureUnLoCode: "JESTH", arrivalUnLoCode: "GBPOO" };
  if (legacyRoute === "POSH") return { departureUnLoCode: "GBPOO", arrivalUnLoCode: "JESTH" };
  if (legacyRoute === "SHSP") return { departureUnLoCode: "JESTH", arrivalUnLoCode: "GGSPT" };
  if (legacyRoute === "SPSH") return { departureUnLoCode: "GGSPT", arrivalUnLoCode: "JESTH" };
  if (legacyRoute === "TMAL") return { departureUnLoCode: "MAPTM", arrivalUnLoCode: "ESALG" };
  if (legacyRoute === "ALTM") return { departureUnLoCode: "ESALG", arrivalUnLoCode: "MAPTM" };
  if (legacyRoute === "ALCE") return { departureUnLoCode: "ESALG", arrivalUnLoCode: "ESCEU" };
  if (legacyRoute === "CEAL") return { departureUnLoCode: "ESCEU", arrivalUnLoCode: "ESALG" };
  if (legacyRoute === "KPPA") return { departureUnLoCode: "SEKPS", arrivalUnLoCode: "EEPLA" };
  if (legacyRoute === "PAKP") return { departureUnLoCode: "EEPLA", arrivalUnLoCode: "SEKPS" };
  if (legacyRoute === "ANNE") return { departureUnLoCode: "NLIJM", arrivalUnLoCode: "GBTYN" };
  if (legacyRoute === "ANOV") return { departureUnLoCode: "NLIJM", arrivalUnLoCode: "NLAMS" };
  if (legacyRoute === "CHDA") return { departureUnLoCode: "DKCPH", arrivalUnLoCode: "DKCPH" };
  if (legacyRoute === "CHOS") return { departureUnLoCode: "DKCPH", arrivalUnLoCode: "NOOSL" };
  if (legacyRoute === "COAR") return { departureUnLoCode: "DKCPH", arrivalUnLoCode: "DKAAR" };
  if (legacyRoute === "COCO") return { departureUnLoCode: "DKCPH", arrivalUnLoCode: "DKCPH" };
  if (legacyRoute === "DPNH") return { departureUnLoCode: "FRDPE", arrivalUnLoCode: "GBNHV" };
  if (legacyRoute === "FHOS") return { departureUnLoCode: "DKFDH", arrivalUnLoCode: "NOOSL" };
  if (legacyRoute === "HKPA") return { departureUnLoCode: "FIHKO", arrivalUnLoCode: "EEPLA" };
  if (legacyRoute === "KHKL") return { departureUnLoCode: "SEKAN", arrivalUnLoCode: "LTKLJ" };
  if (legacyRoute === "KIKL") return { departureUnLoCode: "DEKEL", arrivalUnLoCode: "LTKLJ" };
  if (legacyRoute === "KLKH") return { departureUnLoCode: "LTKLJ", arrivalUnLoCode: "SEKAN" };
  if (legacyRoute === "KLKI") return { departureUnLoCode: "LTKLJ", arrivalUnLoCode: "DEKEL" };
  if (legacyRoute === "NEAN") return { departureUnLoCode: "GBTYN", arrivalUnLoCode: "NLIJM" };
  if (legacyRoute === "NHDP") return { departureUnLoCode: "GBNHV", arrivalUnLoCode: "FRDPE" };
  if (legacyRoute === "OSCH") return { departureUnLoCode: "NOOSL", arrivalUnLoCode: "DKCPH" };
  if (legacyRoute === "OSFH") return { departureUnLoCode: "NOOSL", arrivalUnLoCode: "DKFDH" };
  if (legacyRoute === "PAHK") return { departureUnLoCode: "EEPLA", arrivalUnLoCode: "FIHKO" };
  if (legacyRoute === "DKRO") return { departureUnLoCode: "FRDKK", arrivalUnLoCode: "IEROE" };
  if (legacyRoute === "RODK") return { departureUnLoCode: "IEROE", arrivalUnLoCode: "FRDKK" };
  if (legacyRoute === "SHPM") return { departureUnLoCode: "JESTH", arrivalUnLoCode: "GBPME" };
  if (legacyRoute === "PMSH") return { departureUnLoCode: "GBPME", arrivalUnLoCode: "JESTH" };
  if (legacyRoute === "KLTR") return { departureUnLoCode: "LTKLJ", arrivalUnLoCode: "SETRG" };
  if (legacyRoute === "TRKL") return { departureUnLoCode: "SETRG", arrivalUnLoCode: "LTKLJ" };
  throw new Error(`Unmapped legacy route --> ${legacyRoute ?? "null"}`);
};
var mapUnloRoute = (unloCode) => {
  if (unloCode === "GBDVR-FRDKK") return "DVDK";
  if (unloCode === "FRDKK-GBDVR") return "DKDV";
  if (unloCode === "GBDVR-FRCQF") return "DVCA";
  if (unloCode === "FRCQF-GBDVR") return "CADV";
  if (unloCode === "FRSML-JESTH") return "SMSH";
  if (unloCode === "JESTH-FRSML") return "SHSM";
  if (unloCode === "JESTH-GBPOO") return "SHPO";
  if (unloCode === "GBPOO-JESTH") return "POSH";
  if (unloCode === "JESTH-GGSPT") return "SHSP";
  if (unloCode === "GGSPT-JESTH") return "SPSH";
  if (unloCode === "MAPTM-ESALG") return "TMAL";
  if (unloCode === "ESALG-MAPTM") return "ALTM";
  if (unloCode === "ESALG-ESCEU") return "ALCE";
  if (unloCode === "ESCEU-ESALG") return "CEAL";
  if (unloCode === "SEKPS-EEPLA") return "KPPA";
  if (unloCode === "EEPLA-SEKPS") return "PAKP";
  if (unloCode === "NLIJM-GBTYN") return "ANNE";
  if (unloCode === "NLIJM-NLAMS") return "ANOV";
  if (unloCode === "DKCPH-DKCPH") return "CHDA";
  if (unloCode === "DKCPH-NOOSL") return "CHOS";
  if (unloCode === "DKCPH-DKAAR") return "COAR";
  if (unloCode === "FRDPE-GBNHV") return "DPNH";
  if (unloCode === "DKFDH-NOOSL") return "FHOS";
  if (unloCode === "FIHKO-EEPLA") return "HKPA";
  if (unloCode === "SEKAN-LTKLJ") return "KHKL";
  if (unloCode === "DEKEL-LTKLJ") return "KIKL";
  if (unloCode === "LTKLJ-SEKAN") return "KLKH";
  if (unloCode === "LTKLJ-DEKEL") return "KLKI";
  if (unloCode === "GBTYN-NLIJM") return "NEAN";
  if (unloCode === "GBNHV-FRDPE") return "NHDP";
  if (unloCode === "NOOSL-DKCPH") return "OSCH";
  if (unloCode === "NOOSL-DKFDH") return "OSFH";
  if (unloCode === "EEPLA-FIHKO") return "PAHK";
  if (unloCode === "FRDKK-IEROE") return "DKRO";
  if (unloCode === "IEROE-FRDKK") return "RODK";
  if (unloCode === "JESTH-GBPME") return "SHPM";
  if (unloCode === "GBPME-JESTH") return "PMSH";
  if (unloCode === "LTKLJ-SETRG") return "KLTR";
  if (unloCode === "SETRG-LTKLJ") return "TRKL";
  throw new Error(`Unmapped unloCode --> ${unloCode ?? "null"}`);
};
var getCompoundRoute = (legacyRoute) => {
  if (legacyRoute === "DVCA") return "DVDK";
  if (legacyRoute === "DVDK") return "DVCA";
  if (legacyRoute === "CADV") return "DKDV";
  if (legacyRoute === "DKDV") return "CADV";
  return null;
};
var isCompoundRoute = (departurePortUnloCode, arrivalPortUnloCode) => {
  const route = mapUnloRoute(`${departurePortUnloCode}-${arrivalPortUnloCode}`);
  return route ? compoundRoutes.includes(route.toUpperCase()) : false;
};
var seabookRouteMap = [
  { seabook: "CADV", route: "FRCQF-GBDVR" },
  { seabook: "DKDV", route: "FRDKK-GBDVR" },
  { seabook: "DVCA", route: "GBDVR-FRCQF" },
  { seabook: "DVDK", route: "GBDVR-FRDKK" },
  { seabook: "KPPA", route: "SEKPS-EEPLA" },
  { seabook: "PAKP", route: "EEPLA-SEKPS" },
  { seabook: "ANNE", route: "NLIJM-GBTYN" },
  { seabook: "ANOV", route: "NLIJM-NLAMS" },
  { seabook: "CHDA", route: "DKCPH-DKCPH" },
  { seabook: "CHOS", route: "DKCPH-NOOSL" },
  { seabook: "COAR", route: "DKCPH-DKAAR" },
  { seabook: "COCO", route: "DKCPH-DKCPH" },
  { seabook: "DPNH", route: "FRDPE-GBNHV" },
  { seabook: "FHOS", route: "DKFDH-NOOSL" },
  { seabook: "HKPA", route: "FIHKO-EEPLA" },
  { seabook: "KHKL", route: "SEKAN-LTKLJ" },
  { seabook: "KIKL", route: "DEKEL-LTKLJ" },
  { seabook: "KLKH", route: "LTKLJ-SEKAN" },
  { seabook: "KLKI", route: "LTKLJ-DEKEL" },
  { seabook: "NEAN", route: "GBTYN-NLIJM" },
  { seabook: "NHDP", route: "GBNHV-FRDPE" },
  { seabook: "OSCH", route: "NOOSL-DKCPH" },
  { seabook: "OSFH", route: "NOOSL-DKFDH" },
  { seabook: "PAHK", route: "EEPLA-FIHKO" },
  { seabook: "DKRO", route: "FRDKK-IEROE" },
  { seabook: "RODK", route: "IEROE-FRDKK" },
  { seabook: "SHSM", route: "JESTH-FRSML" },
  { seabook: "SMSH", route: "FRSML-JESTH" },
  { seabook: "SHPO", route: "JESTH-GBPOO" },
  { seabook: "POSH", route: "GBPOO-JESTH" },
  { seabook: "SHPM", route: "JESTH-GBPME" },
  { seabook: "PMSH", route: "GBPME-JESTH" },
  { seabook: "SHSP", route: "JESTH-GGSPT" },
  { seabook: "SPSH", route: "GGSPT-JESTH" },
  { seabook: "TMAL", route: "MAPTM-ESALG" },
  { seabook: "ALTM", route: "ESALG-MAPTM" },
  { seabook: "KLTR", route: "LTKLJ-SETRG" },
  { seabook: "TRKL", route: "SETRG-LTKLJ" },
  { seabook: "ALCE", route: "ESALG-ESCEU" },
  { seabook: "CEAL", route: "ESCEU-ESALG" }
];
function getUnlocodeFromRouteCode(routeCode) {
  var _a;
  const code = routeCode.toUpperCase();
  return (_a = seabookRouteMap.find(({ seabook }) => seabook === code)) == null ? void 0 : _a.route;
}
function normalizeRouteCodeToUnlocode(routeCode) {
  var _a;
  const code = routeCode.toUpperCase();
  return (_a = seabookRouteMap.find(({ route, seabook }) => route === code || seabook === code)) == null ? void 0 : _a.route;
}

// src/salesowner.ts
var getSalesownerForRoute = (route, locale) => {
  const isSogRoute = sogRoutes.includes(route);
  if (isSogRoute) {
    return locale === "fr-ma" ? { id: "25", currency: "MAD" } : { id: "24", currency: "EUR" };
  }
  if (locale === "pl-pl") return { id: "14", currency: "GBP" };
  if (locale === "en") return { id: "19", currency: "EUR" };
  if (["es-es", "fr-fr", "fr-ma", "fr-be", "de-de", "nl-nl", "nl-be"].includes(locale)) return { id: "19", currency: "EUR" };
  if (secondaryMarkets.includes(locale)) return { id: "19", currency: "EUR" };
  else {
    return { id: "14", currency: "GBP" };
  }
};
var getSalesowner = (departurePortUnloCode, arrivalPortUnloCode, locale) => getSalesownerForRoute(mapUnloRoute(`${departurePortUnloCode}-${arrivalPortUnloCode}`), locale);
var secondaryMarkets = [
  "sv-se",
  "et-ee",
  "da-dk",
  "it-it",
  "ru-ru",
  "nb-no",
  "lt-lt",
  "lv-lv",
  "fi-fi",
  "pt-br",
  "bg-bg",
  "cs-cz",
  "sk-sk",
  "zh-cn",
  "ja-jp",
  "ko-kr",
  "ro-ro"
];

// src/environment-vars.ts
var nullCheck = (obj) => new Proxy(obj, {
  get: (obj2, name) => {
    const val = obj2[name];
    if (val === void 0) throw new Error(`not found: ${String(name)}`);
    if (typeof val !== "string") throw new Error(`${String(name)} must be a string`);
    return val;
  }
});
var processEnv = typeof process !== "undefined" && process.env ? process.env : {};
var env = nullCheck(processEnv);

// src/cookies.ts
var ACCESS_TOKEN_COOKIE_KEY = "dfds-paxob-access-token";
var SESSION_TOKEN_COOKIE_KEY = "dfds-paxob-session-token";
var AMENDMENT_COOKIE_KEY = "dfds-paxob-amendment";
var OUTSTANDING_TOKEN_KEY = "dfds-paxob-outstanding-token";

// src/consts.ts
var CONTENTFUL_URL_SLUG_CUSTOMER_SERVICE = "5XPpxRkiBZJEpc93sJ6J90";
var CONTENTFUL_URL_SLUG_TERMS_AND_CONDITION = "0RogKVNNRV3uCsrpooZb9";
var CONTENTFUL_URL_SLUG_PRIVACY_POLICY = "4knAJpzIYQeZIsbRAToHZP";
var CONTENTFUL_URL_SLUG_PET_TRAVEL = "67y9JM9jDFtZyUtuMjZy3j";
var HELLMAN_ORIGIN = "https://api.hellman.oxygen.dfds.cloud";
var POST_LOGIN_TARGET_KEY = "pax_postLoginTarget";

// src/dates.ts
import { format, parseISO } from "date-fns";
import { bg, cs, da, de, enGB, es, et, fi, fr, it, ja, ko, lt, lv, nb, nl, nlBE, pl, pt, ro, ru, sk, sv } from "date-fns/locale";
var longDateFormat = (locale, date) => date ? format(parseISO(date), "EEEE dd MMMM yyyy", { locale: getDatepickerLocale(locale) }) : null;
var shortDateFormat = (locale, date) => date ? format(parseISO(date), "dd MMM yyyy", { locale: getDatepickerLocale(locale) }) : void 0;
var dayFormat = (locale, date) => date ? format(parseISO(date), "EEEE", { locale: getDatepickerLocale(locale) }) : null;
var extraLongDateFormat = (locale, date) => date ? format(parseISO(date), "EEEE, dd MMMM yyyy", { locale: getDatepickerLocale(locale) }) : null;
var standardDateFormat = (locale, date) => date ? format(parseISO(date), "dd-MM-yyyy", { locale: getDatepickerLocale(locale) }) : void 0;
var extraShortDateFormat = (locale, date) => date ? format(parseISO(date), "dd MMM", { locale: getDatepickerLocale(locale) }) : void 0;
var extractTime = (isoTime) => {
  var _a;
  return (_a = isoTime == null ? void 0 : isoTime.match(/..:../)) == null ? void 0 : _a[0];
};
var DEFAULT_DATE_FNS_LOCALES = {
  "bg-bg": bg,
  "cs-cz": cs,
  "da-dk": da,
  "de-de": de,
  en: enGB,
  "en-gb": enGB,
  "es-es": es,
  "et-ee": et,
  "fi-fi": fi,
  "fr-be": fr,
  "fr-fr": fr,
  "fr-ma": fr,
  "it-it": it,
  "ja-jp": ja,
  "ko-kr": ko,
  "lt-lt": lt,
  "lv-lv": lv,
  "nb-no": nb,
  "nl-be": nlBE,
  "nl-nl": nl,
  "pl-pl": pl,
  "pt-br": pt,
  "ro-ro": ro,
  "ru-ru": ru,
  "sk-sk": sk,
  "sv-se": sv
};
var PAXOB_DATE_FNS_LOCALES = {
  "de-de": de,
  en: enGB,
  "en-gb": enGB,
  "es-es": es,
  "fr-be": fr,
  "fr-fr": fr,
  "fr-ma": fr,
  "nl-be": nl,
  "nl-nl": nl,
  "pl-pl": pl
};
function getDatepickerLocale(locale) {
  return DEFAULT_DATE_FNS_LOCALES[locale == null ? void 0 : locale.toLowerCase()] ?? enGB;
}
function getPaxObDatepickerLocale(locale) {
  return PAXOB_DATE_FNS_LOCALES[locale == null ? void 0 : locale.toLowerCase()] ?? enGB;
}

// src/urls.ts
var ferryUrls = [
  {
    account: "account",
    bookings: "bookings",
    ferry: "passenger-ferries",
    locales: [
      "en",
      "en-gb",
      "bg-bg",
      "zh-cn",
      "cs-cz",
      "fi-fi",
      "it-it",
      "ja-jp",
      "ko-kr",
      "pt-br",
      "ro-ro",
      "ru-ru",
      "sk-sk",
      "tr-tr"
    ]
  },
  {
    account: "cuenta",
    bookings: "reservas",
    ferry: "ferris-de-pasajeros",
    locales: ["es-es"]
  },
  {
    account: "bruger",
    bookings: "bookinger",
    ferry: "passagerfaerger",
    locales: ["da-dk"]
  },
  {
    account: "account",
    bookings: "boekingen",
    ferry: "overtochten-passagiers",
    locales: ["nl-be", "nl-nl"]
  },
  {
    account: "konto",
    bookings: "broneeringuid",
    ferry: "reisilaevad",
    locales: ["et-ee"]
  },
  {
    account: "compte",
    bookings: "mes-reservations",
    ferry: "ferries-passagers",
    locales: ["fr-be", "fr-fr", "fr-ma"]
  },
  {
    account: "account",
    bookings: "buchungen",
    ferry: "passagierfaehren",
    locales: ["de-de"]
  },
  {
    account: "konts",
    bookings: "rezervacijas",
    ferry: "pasazieru-pramji",
    locales: ["lv-lv"]
  },
  {
    account: "paskyra",
    bookings: "uzsakymai",
    ferry: "keleiviniai-keltai",
    locales: ["lt-lt"]
  },
  {
    account: "konto",
    bookings: "bestillinger",
    ferry: "ferge",
    locales: ["nb-no"]
  },
  {
    account: "konto",
    bookings: "rezerwacje",
    ferry: "promy-pasazerskie",
    locales: ["pl-pl"]
  },
  {
    account: "konto",
    bookings: "bokningar",
    ferry: "passagerarfartyg",
    locales: ["sv-se"]
  }
];

// src/vehicle.ts
var getVehicleResourceKey = (vehicleCode) => {
  switch (vehicleCode) {
    case "NCAR":
      return "VEHICLE-NAME-NCAR";
    case "BIKV":
    case "BIKVRES":
      return "VEHICLE-NAME-BIKV";
    case "PVANM":
      return "VEHICLE-NAME-PVANM";
    case "PVANB":
    case "PVANBRES":
      return "VEHICLE-NAME-PVANB";
    case "MOC":
    case "MOCRES":
      return "VEHICLE-NAME-MOC";
    case "MOCS":
      return "VEHICLE-NAME-MOCS";
    case "CARH":
      return "VEHICLE-NAME-CARH";
    case "CAR":
    case "CARRES":
      return "VEHICLE-NAME-CAR";
    case "CARZ":
      return "VEHICLE-NAME-CARZ";
    case "CARB":
      return "VEHICLE-NAME-CARB";
    case "CARS":
      return "VEHICLE-NAME-CARS";
    case "CARLW":
      return "VEHICLE-NAME-CARLW";
    case "MCVB":
    case "MCVBRES":
      return "VEHICLE-NAME-MCVB";
    case "MCVM":
      return "VEHICLE-NAME-MCVM";
    case "MCVX":
      return "VEHICLE-NAME-MCVX";
    case "MCVS":
      return "VEHICLE-NAME-MCVS";
    case "MIBUS":
      return "VEHICLE-NAME-MIBUS";
    case "BUS":
    case "BUSRES":
      return "VEHICLE-NAME-BUS";
    case "CARX":
      return "VEHICLE-NAME-CARX";
    case "CAMB":
      return "TRAILER-NAME-CAMB";
    case "CAMS":
    case "CAMSRES":
      return "TRAILER-NAME-CAMS";
    case "TRAX":
      return "TRAILER-NAME-TRAX";
    case "TRAB":
      return "TRAILER-NAME-TRAB";
    case "TRAS":
      return "TRAILER-NAME-TRAS";
    case "TRAZ":
    case "TRAZRES":
      return "TRAILER-NAME-TRAZ";
    case "NTRAILER":
      return "TRAILER-NAME-NTRAILER";
    default:
      return vehicleCode;
  }
};

// src/locale.ts
var getContentfulLocale = (locale) => {
  if (locale == null ? void 0 : locale.includes("-")) {
    const parts = locale.split("-");
    locale = `${parts[0]}-${parts[1].toUpperCase()}`;
  }
  return locale ?? "en";
};
function getSupportedLocale(locale) {
  const localeLower = locale.toLowerCase();
  if (secondaryMarkets.includes(localeLower)) return "en";
  return locale;
}
var mapToSeabookLanguageCode = (locale = "") => {
  const languageMap = {
    de: "DE",
    en: "EN",
    fr: "FR",
    nl: "NL",
    pl: "PL",
    es: "ES"
  };
  const languageCode = locale.split("-")[0];
  return languageMap[languageCode] || "EN";
};
export {
  ACCESS_TOKEN_COOKIE_KEY,
  AMENDMENT_COOKIE_KEY,
  CONTENTFUL_URL_SLUG_CUSTOMER_SERVICE,
  CONTENTFUL_URL_SLUG_PET_TRAVEL,
  CONTENTFUL_URL_SLUG_PRIVACY_POLICY,
  CONTENTFUL_URL_SLUG_TERMS_AND_CONDITION,
  HELLMAN_ORIGIN,
  OUTSTANDING_TOKEN_KEY,
  POST_LOGIN_TARGET_KEY,
  PaxObProducts,
  SESSION_TOKEN_COOKIE_KEY,
  compoundRoutes,
  compoundUnlocodeRoutes,
  dayFormat,
  env,
  extraLongDateFormat,
  extraShortDateFormat,
  extractTime,
  ferryUrls,
  getCompoundRoute,
  getContentfulLocale,
  getDatepickerLocale,
  getEconomyProduct,
  getPaxObDatepickerLocale,
  getPremiumProduct,
  getSalesowner,
  getSalesownerForRoute,
  getSupportedLocale,
  getUnlocodeFromRouteCode,
  getVehicleResourceKey,
  isChannelProduct,
  isCompoundRoute,
  isJerseyProduct,
  isSogProduct,
  jerseyRoutes,
  jerseyUnlocodeRoutes,
  longDateFormat,
  mapRoute,
  mapToSeabookLanguageCode,
  mapUnloRoute,
  normalizeRouteCodeToUnlocode,
  seabookRouteMap,
  secondaryMarkets,
  shortDateFormat,
  sogRoutes,
  sogUnlocodeRoutes,
  standardDateFormat
};
//# sourceMappingURL=index.js.map